export default "data:video/mp2t;base64,aW1wb3J0IGxpY2VuY2UgZnJvbSAiLi9saWNlbmNlIjsKCmV4cG9ydCBkZWZhdWx0IHsKICBsaWNlbmNlLAp9Owo="